import React, { useState, useEffect,useContext } from "react"
import {GlobalContext} from '../functions'
import { Link } from "gatsby"
import styled from "styled-components"
import DateTimePicker from "react-date-picker"
import { FaRegCalendarAlt, FaCaretDown, FaShareSquare } from "react-icons/fa"
import { FiPlusCircle, FiMinusCircle } from "react-icons/fi"
import Moment from "moment"
import "../Css/main.css"
import DataListInput from "react-datalist-input"
var SearchBG = styled.div`
  min-height: 80px;
  background-color: white;
  max-width: 940px;
  display: flex;
  margin: 30px auto;
  padding: 10px 20px;
  border-radius: 10px;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  @media screen and (max-width: 450px) {
    background:none;
  }
`
// var DataListInput =DataListInput
// var DateTimePicker = DateTimePicker

var SearchBtn = styled.a`
cursor:pointer;
  padding: 10px 5%;
  color: white;
  width: 90%;
  background: #e10000;
  min-width: max-content;
  border-radius: 5px;
  font-size: 2.1rem;
  font-weight: 400;
  text-align:center;
  display: ${props => (props.display ? "none" : "block")};
&:hover{
  box-shadow: 0 2px 5px 0 rgba(29,29,29,.2),0 2px 10px 0 rgba(29,29,29,.2);
}
  @media screen and (min-width: 451px) {
    width: 85%;
  }
  @media screen and (max-width: 1010px) {
    display: ${props => (props.display ? "block" : "none")};
  }
  @media screen and (min-width: 1011px) {
    width: 6%;
  }
`
var InputWrap = styled.div`
  margin: 10px 0px 10px 0;
  background:white;
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  width: 38%;
  @media screen and (max-width: 1010px) {
    width: 100%;
  }
  @media screen and (max-width: 450px) {
    border-radius: 4px 4px 4px 4px;
  }
`
const SearchDiv = styled.div`
  padding: 5px;
  width: 45%;
  display: flex;
  flex-direction: column;
  border: 1px solid #bec5cf;
  ${props => (props.left ? "border-right:1px solid #bec5cf" : "")};
  border-radius: ${props => (props.left ? "4px 0 0 4px" : "0 4px 4px 0")};
  @media screen and (max-width: 500px) {
      width:${props=>props.date?"46%":"100%"};
      border-radius: ${props => (props.left ? "4px 4px 0 0" : "0 0 4px 4px")};
  }
  @media screen and (max-width: 400px) {
      width:100%;
      border-radius: ${props => (props.left ? "4px 4px 0 0" : "0 0 4px 4px")};
  }
`
const SearchSpan = styled.span`
  font-size: 1.3rem;

  color: #72777e;
`
const Options = styled.div`
  width: 80%;
  display: flex;
  flex-wrap:wrap;
  align-items: center;
  @media screen and (max-width: 1010px) {
      justify-content:center;
      width:100%;
  }
`
const OptionChild = styled.div`
  width: 31%;
  @media screen and (max-width: 700px) {
      width: 45%;
    padding-left: 10px;
      display:${props=>props.multi?"none":"block"}
  }
  @media screen and (max-width: 450px) {
      width: 100%;
      color:white !important;
      margin-left:-8px;
  }
`
const ToggleDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 2px;
  position: relative;
`
const ToggleSpan = styled.span``
const DropDown = styled.div`
  width: 100%;
  z-index: 2;
  position: absolute;
  min-height: 200px;
  display: ${props => (props.display ? "block" : "none")};
  background: white;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1.4rem;
  color: #333;
  border: 1px solid rgba(29, 29, 29, 0.15);
  border-radius: 0.4rem;
  top: 26px;
`
const IncDiv = styled.div`
  display: flex;
  padding: 10px;
  border-bottom: 1px solid #bec5cf;
`
const IncText = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
`
const IncHead = styled.span`
  color: #1d1d1d;
  line-height: 1.3;
  font-size: 1.8rem;
`
const IncSmall = styled.small`
  font-size: 90%;
  font-weight: 400;
  color: #bec5cf;
`
const IncCounter = styled.div`
  width: 50%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  font-size: 28px;
  font-weight: 300;
`
const IncValue = styled.span``
const DoneButton = styled.button`
  margin: 10px auto;
  background: #e10000;
  border-radius: 4px;
  border: 0 solid #fff;
  font-size: 1.8rem;
  padding: 1rem;
  min-width: 150px;
  color: white;
`
const IncrementorCmp = props => {
  // console.log("Total", props.total)
  var InrangeDown = props.total <= 9 && props.total > 1 && props.value > 0
  var InrangeUp = props.total < 9 && props.total >= 0
  var Limit = props.total == 1 || props.total == 9
  //   console.log("range", InrangeDown,InrangeUp)
  return (
    <IncDiv>
      <IncText>
        <IncHead>{props.heading}</IncHead>
        <IncSmall>{props.subtext}</IncSmall>
      </IncText>
      <IncCounter>
        <FiMinusCircle
          style={{
            cursor: "pointer",
            color: InrangeDown ? "black" : "#bec5cf",
          }}
          onClick={() => (InrangeDown ? props.SetValue(props.value - 1) : null)}
        />
        <IncValue>{props.value}</IncValue>
        <FiPlusCircle
          style={{
            color: InrangeUp ? "#e10000" : "#F07F7F",
            cursor: "pointer",
          }}
          onClick={() => (InrangeUp ? props.SetValue(props.value + 1) : null)}
        />
      </IncCounter>
    </IncDiv>
  )
}
const InputPromo = styled.input`
  color: black;
  border: none;
  border-radius: 4px;
  padding: 0.8rem 1.2rem;
  & :focus,
  :hover {
    border: 1px solid #0275d8;
  }

  @media screen and (max-width: 450px) {
    color: white;
    background-color:transparent;
    font-size:12px;
    margin-left:-8px
  }

  &::placeholder {
    color: black;
    font-size: larger;
    font-weight: 500;
    @media screen and (max-width: 450px) {
      background-color:transparent;
      color:white !important;
      border-width:0px;
  }
  }
`
const MultiCity = styled.a`
  font-size: 1.4rem;
  font-weight: 400;
  color: black;
  line-height: 1.5;
  &:hover {
    color: red;
  }
`
const RespSearchDiv = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  @media screen and (max-width: 1010px) {
    margin: 10px 0;
  }
`
export default function SearchWidget(props) {
  let SD = new Date()
  let ED = new Date()
  ED.setDate(ED.getDate() + 7)
  var [startDate, setStartDate] = useState(SD)
  var [EndDate, setEndDate] = useState(ED)
  var [Toggle, setToggle] = useState(false)
  var [Promo, setPromo] = useState("N")
  var [Adult, setAdult] = useState(1)
  var [child, setChild] = useState(0)
  var [infant, setInfant] = useState(0)
  var [Total, SetTotal] = useState(1)
  var [Origin, SetOrigin] = useState([])
  var [Dest, SetDest] = useState([])
  var [OriginSelected, SetOriginSelected] = useState(null)
  var [DestSelected, SetDestSelected] = useState(null)
  var GetContext = useContext(GlobalContext)
//console.log("api",props.api)
  const today = new Date();
  // var currency = GetContext.state.currency
  // var LanguageURL = GetContext.state.lang
  Moment.locale("en")
  //   console.log("date",startDate,EndDate, )
  var DeepLink =(currency,LanguageURL)=> `https://www.airasia.com/select/${LanguageURL}/${
    OriginSelected ? OriginSelected.key : "N"
  }/${DestSelected ? DestSelected.key : "N"}/${Moment(startDate).format(
    "YYYY-MM-DD"
  )}/${Moment(EndDate).format(
    "YYYY-MM-DD"
  )}/${Adult}/${child}/${infant}/R/${Promo}/${currency}/ST`
  // console.log("deep", DeepLink)
  useEffect(() => {
    fetch("https://sch.apiairasia.com/station/en-gb/file.json")
      .then(response => response.json())
      .then(data =>
        SetOrigin(
          data.map(x => {
            return {
              key: x.StationCode,
              label: `${x.StationName} (${x.StationCode})`,
            }
          })
        )
      )
  }, [])
  useEffect(() => {
    //   console.log("origin",OriginSelected)
    if (OriginSelected)
      fetch(
        `https://sch.apiairasia.com/v2/destination/${OriginSelected.key.toLocaleLowerCase()}/file.json`
      )
        .then(response => response.json())
        .then(data =>
          SetDest(
            []
              .concat(...Object.values(data).map(x => Object.keys(x)))
              .map(x => {
                // if(props.api[x])
                return props.api[x]?{ key: x, label: `${props.api[x]} (${x})` }:null
              }).filter(x=>x!=null)
          )
        )
  }, [OriginSelected])
  useEffect(() => {
    SetTotal(Adult + child + infant)
  }, [Adult, child, infant])
  var DropJson = [
    {
      heading: "Adults",
      subtext: "12+ years",
      value: Adult,
      SetValue: setAdult,
    },
    {
      heading: "Children",
      subtext: "2 - 11 years",
      value: child,
      SetValue: setChild,
    },
    {
      heading: "Infant",
      subtext: "Under 2 years",
      value: infant,
      SetValue: setInfant,
    },
  ]

  return (
    <SearchBG>
      <InputWrap>
        <SearchDiv left>
          <SearchSpan>Origin</SearchSpan>
          <DataListInput items={Origin} onSelect={SetOriginSelected} />
        </SearchDiv>
        <SearchDiv>
          <SearchSpan>Destination</SearchSpan>
          <DataListInput items={Dest} onSelect={SetDestSelected} />
        </SearchDiv>
      </InputWrap>
      <InputWrap>
        <SearchDiv left date className="departureDateBox">
          <SearchSpan>Departure Date</SearchSpan>
          <DateTimePicker
            calendarIcon={<FaRegCalendarAlt />}
            onChange={setStartDate}
            value={startDate}
            minDate={today}
          />
        </SearchDiv>
        <SearchDiv date className="returnDateBox">
          <SearchSpan>Return Date</SearchSpan>
          <DateTimePicker
            calendarIcon={<FaRegCalendarAlt />}
            onChange={setEndDate}
            value={EndDate}
            minDate={startDate}
          />
        </SearchDiv>
      </InputWrap>
      <GlobalContext.Consumer>
      {value=>  {
        return <SearchBtn onClick={()=>OriginSelected&&DestSelected?window.location= DeepLink(value.state.currency,value.state.lang):null}>
        Search
      </SearchBtn>}}
      </GlobalContext.Consumer>
      <Options>
        <OptionChild>
          <ToggleDiv
            onBlur={() => {
              setToggle(false)
            }}
            tabIndex="1"
          >
            <div
              onClick={() => {
                setToggle(!Toggle)
              }}
              style={{ width: "100%", display: "flex", alignItems: "center" }}
            >
              <ToggleSpan>
                {DropJson.map(x => (x.value ? x.value + " " + x.heading : null))
                  .filter(x => x != null)
                  .join(", ")}
              </ToggleSpan>
              <FaCaretDown style={{ margin: "0 5px" }} />
            </div>
            <DropDown display={Toggle}>
              {DropJson.map((x,index) => (
                <IncrementorCmp {...x} total={Total} setTotal={SetTotal} key={"searchWidget"+index} />
              ))}
              <div style={{ display: "flex" }}>
                <DoneButton onClick={() => setToggle(false)}>Done</DoneButton>
              </div>
            </DropDown>
          </ToggleDiv>
        </OptionChild>
        <OptionChild>
          <InputPromo
            placeholder="Promo code"
            onChange={val => setPromo(val.target.value)}
          />
        </OptionChild>
        <OptionChild multi> 
          <MultiCity
            target="_blank"
            href="https://booking2.airasia.com/MultiCitySearch.aspx?culture=en-GB"
          >
            <FaShareSquare /> Multi-city
          </MultiCity>
        </OptionChild>
      </Options>
      <RespSearchDiv>
      <GlobalContext.Consumer>
      {value=>  {
        return <SearchBtn display
        onClick={()=>OriginSelected&&DestSelected?window.location= DeepLink(value.state.currency,value.state.lang):null}>
        Search
      </SearchBtn>}}
      </GlobalContext.Consumer>
      </RespSearchDiv>
    </SearchBG>
  )
}
